/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import CheckBoxInput from '../common/CheckBoxInput';
import Button from '../common/Button';
import {Link} from 'react-router';
import {ITAAlert} from '../common/ITAAlert';
import * as pathConstants from '../../constants/pathConstants';
import '../../styles/fileUpload/FileUploadForm.css';
import * as FileUploadConstants from '../../constants/fileUploadConstants';

const FileUploadForm = ({
                          form,
                          uploadFile,
                          onSubmit,
                          onClick,
                          onCancel,
                          formIsValid,
                          uploadFailed,
                          fileUploadAgreement,
                          error,
                          downloadUrl
                        }) => {
  let questions = [];
  if (form.formQuestions) {
    form.formQuestions.forEach(question => {
      let questionParts = [];
      question.questionParts.map(questionPart => {
        let type = questionPart.questionPartType;
        if (type === '1') {
          questionParts.push(
            <span className="question-part"
                  key={questionPart.questionPartName}>
                <CheckBoxInput
                  name=""
                  label={questionPart.questionPartLabel}
                  options={questionPart.questionPartOptions}
                  onChange={onClick}
                  checked={fileUploadAgreement}
                />
              </span>
          );
        }
      });
      questions.push(
        <span className="question"
              key={question.questionID || question.questionName}>
          {question.questionGroupHelpText &&
          <div
            dangerouslySetInnerHTML={{__html: question.questionGroupHelpText}}/>}
          {questionParts}
        </span>
      );
    });
  }
  return (
    <div id="file-upload-panel">
      <div className="panel-heading row">
        <div className="alert alert-danger" hidden={!error}>
          <div className="first-line">{error}</div>
          <div className="second-line" hidden={!downloadUrl}>{FileUploadConstants.ALTERNATIVE_CLEANED_FILE} <a href={downloadUrl} download="cleaned_file.csv">here</a></div>
        </div>
        {!uploadFailed &&
        <ITAAlert style="success"
                  message={
                    <div className="first-line">
                      Your file was successfully submitted, you will receive <em className="text-underline"><strong>two</strong></em> emails once it has been successfully processed. If you do not receive the <em className="text-underline">second</em> e-mail, your file DID NOT properly load. <span className="text-normal">Visit the FAQs guidance on common errors that block a file from loading</span>.
                    </div>
                  }/>
        }
        <div className=" mobile-warning">
          <ITAAlert style="warning"
                    message={
                      <div className="first-line">
                        This feature may not work on your device.
                      </div>
                    }/>
        </div>

      </div>
      <div>
          <p className='non-mobile'><strong>ATTENTION:</strong> Submitting your data by CSV file will generate <em className="text-underline"><strong>two</strong></em> confirmation e-mails. If you do not receive the second e-mail, your data <strong>DID NOT</strong> properly load.</p>
          <p className='non-mobile'><strong>NOTE TO USERS: </strong>If you are submitting data for one or a small number of establishments, it is much easier to enter the data using the web forms rather than creating and uploading a CSV file.
          Simply click on the "Create Establishment" button and fill out two web forms for each establishment and you are finished.
          if you have already provided your establishment information for previous collection(s), click "View Establishment List" and select the already entered establishment and provide the new 300A summary data.</p>
          <p className='mobile'><strong>ATTENTION:</strong> Submitting your data by CSV file will generate <em className="text-underline">two</em> confirmation e-mails. If you do not receive the second e-mail, your data <strong>DID NOT</strong> properly load.</p>
          <p className='mobile'><strong>NOTE TO USERS: </strong>If you are submitting data for one or a small number of establishments, it is much easier to enter the data using the web forms rather than creating and uploading a CSV file.
          Simply click on the "Create Establishment" button and fill out two web forms for each establishment and you are finished.
          if you have already provided your establishment information for previous collection(s), click "View Establishment List" and select the already entered establishment and provide the new 300A summary data.</p>
      </div>
      <div>
        <p>This feature allows you to batch upload information about establishments and 300A summary data. &nbsp;</p>
        <p>You can perform the following actions using the file:</p>
        <p>
          <ul>
            <li>Create establishments</li>
            <li>Edit establishment information</li>
            <li>Submit and re-submit 300A data</li>
          </ul>
          <br/>
          To use this feature, follow the steps listed below. For more information,
          see <a href='https://www.osha.gov/injuryreporting/faqs' target='_blank' rel='noopener noreferrer'>Frequently Asked Questions (FAQ)</a> related
          to CSV files. If you encounter any
          issues uploading your file, please submit a request to the ITA Help Desk by
          completing the form located <Link to={pathConstants.pathToHelpRequest}>here</Link>.
          <br/>
        </p>
      </div>
      <div className="file-upload-section">
        <form>
          <div className="step row">
            <div className="col-xs-12">
              <h2> CSV FAQs </h2>
              <div className="item-list">
                <ul className="csv-faqs">
                  <a data-toggle="collapse" href="#faq1" aria-expanded="false" aria-controls="faq1" title="Do I need to submit my data by using
                   the web forms AND in a csv file? Click to expand the answer" className="collapsed">
                    Do I need to submit my data by using the web forms AND in a csv file?
                  </a>
                </ul>
                <ul className="faqbody collapse" id="faq1" aria-expanded="false">
                  <p>No, you only have to provide the data using one of those methods. Please be aware that if you are submitting data for just
                   one or for a small handful of establishments, it is much easier to enter the data manually by selecting the "Create Establishment"
                   button and filling out the two web forms rather than trying to create and upload a csv file. If you have already provided your
                   establishment information for a previous collection (or collections), you only need to click on "View establishment list,"
                   select the already-entered establishment, and provide the new 300A summary data.</p>
                </ul>
              </div>
              <div className="item-list">
                <ul className="csv-faqs">
                  <a data-toggle="collapse" href="#faq2" aria-expanded="false" aria-controls="faq2" title="I am trying to submit my data using a csv
                  file but it keeps stripping the leading zeroes from my Employer Identification Numbers and Zip Codes. How can I fix this problem?
                   Click to expand the answer" className="collapsed">
                    I am trying to submit my data using a csv file but it keeps stripping the leading zeroes from my Employer Identification Numbers
                    and Zip Codes. How can I fix this problem?
                  </a>
                </ul>
                <ul className="faqbody collapse" id="faq2" aria-expanded="false">
                  <p>When you edit a csv file using Excel, it does strip the leading zeroes. To stop that from happening, put an apostrophe (') in
                   front of the zero then save it. Be aware that if you open the file again with Excel, it will strip the zeroes again. You can also
                  edit it with Notepad (right click on the file and choose the "Open with…" feature). Notepad will not strip the zeroes.</p>
                </ul>
              </div>
              <div className="item-list">
                <ul className="csv-faqs">
                  <a data-toggle="collapse" href="#faq3" aria-expanded="false" aria-controls="faq3" title="Can I include decimals in my numbers?
                    Click to expand the answer" className="collapsed">
                    Can I include decimals in my numbers?
                  </a>
                </ul>
                <ul className="faqbody collapse" id="faq3" aria-expanded="false">
                  <p>No. The system will reject the file if you include decimals in any of the number fields. Only enter whole numbers.</p>
                </ul>
              </div>
              <div className="item-list">
                <ul className="csv-faqs">
                  <a data-toggle="collapse" href="#faq4" aria-expanded="false" aria-controls="faq4" title="I use Excel spreadsheets from OSHA’s
                   website as my OSHA forms. Can I save the spreadsheets as csv files to upload to the ITA?
                   Click to expand the answer" className="collapsed">
                    I use Excel spreadsheets from OSHA’s website as my OSHA forms. Can I save the spreadsheets as csv files to upload to the ITA?
                  </a>
                </ul>
                <ul className="faqbody collapse" id="faq4" aria-expanded="false">
                  <p>No, the forms would not be in the correct format, and the system would reject that file. The format must be the same as the
                   template file located at <a href="https://www.osha.gov/injuryreporting/osha_ita_summary_data_csv_template-revised.csv">
                   https://www.osha.gov/injuryreporting/osha_ita_summary_data_csv_template-revised.csv</a>. Please be aware that if
                   you are submitting data for just one or for a small handful of establishments, it is <b>much</b> easier to enter the data manually
                   by selecting the "Create Establishment" button and filling out the two web forms rather than trying to create and upload a csv
                   file. If you have already provided your establishment information for a previous collection(s), you only need to click on
                   "View establishment list," select the already entered establishment and provide the new 300A summary data.</p>
                </ul>
              </div>
              <br/>
              <h2> Step 1: Read the Instructions </h2>
              <div>In order for your file to be processed correctly, it needs to
                contain the establishment and 300A Summary data in a specific
                format.
              </div>
              <br/>
              <div>The instructions for creating a file can be found here: <a
                href="https://www.osha.gov/injuryreporting/osha_ita-estab-and-summary-csv-documentation_revised.pdf"
                target="_blank">File Instructions</a></div>
              <br/>
              <div>A template file can be downloaded here: <a
                href="https://www.osha.gov/sites/default/files/osha_ita_summary_data_csv_template-revised.csv"
                target="_blank">CSV Template</a></div>
              <br/>
              <div>A sample CSV file can be downloaded here: <a
                href="https://www.osha.gov/sites/default/files/osha_ita_summary_data_csv_sample_data-revised.csv"
                target="_blank">CSV Sample</a></div>
              <br/>
              <div>File size cannot exceed 20 MB. For larger files, please split into 20 MB files.</div>
            </div>
          </div>
          <div className="step row">
            <div className="col-xs-12">
              <h2> Step 2: Locate and Select Your File </h2>
              <input type="file" id="file-upload" onChange={uploadFile}/>
            </div>
          </div>
          <div className="step row">
            <div className="col-xs-12">
              {questions}
            </div>
          </div>
          <div className="step row">
              <span className="col-xs-12" id="fileUpload">
                <h2> Step 4: Upload Your File </h2>
                <div>Select "Upload" button to upload your file.</div>
                <div className="button-container">
                  <Button
                    className="submit-file pull-right"
                    value="Upload"
                    disabled={!formIsValid}
                    onClick={onSubmit}/>
                  <a
                    className="btn btn-cancel cancel-file pull-right"
                    disabled={false}
                    href="#"
                    onClick={onCancel}>
                    Cancel
                  </a>

                </div>
              </span>
          </div>
        </form>
      </div>
    </div>
  );
};

FileUploadForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formIsValid: PropTypes.bool.isRequired,
  uploadFailed: PropTypes.bool.isRequired,
  fileUploadAgreement: PropTypes.bool.isRequired,
  error: PropTypes.string,
  downloadUrl: PropTypes.string
};

export default FileUploadForm;



/** WEBPACK FOOTER **
 ** ./src/components/fileUpload/FileUploadForm.js
 **/